(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var BackToTop =
/*#__PURE__*/
function () {
  function BackToTop() {
    _classCallCheck(this, BackToTop);

    this.$backToTop = $('#back-to-top');
    this.toggleDistance = 50;

    if (this.$backToTop.length > 0) {
      this.init();
    }
  }

  _createClass(BackToTop, [{
    key: "init",
    value: function init() {
      var _this = this;

      window.onscroll = function () {
        return _this.scrollFunction();
      };

      this.$backToTop.on('click', function () {
        return _this.scrollToTop();
      });
    }
  }, {
    key: "scrollFunction",
    value: function scrollFunction() {
      if (document.body.scrollTop > this.toggleDistance || document.documentElement.scrollTop > this.toggleDistance) {
        this.$backToTop.css({
          'opacity': '1',
          'cursor': 'pointer',
          'pointer-events': 'all'
        });
      } else {
        this.$backToTop.css({
          'opacity': '0',
          'cursor': 'default',
          'pointer-events': 'none'
        });
      }
    }
  }, {
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo(0, 0);
    }
  }]);

  return BackToTop;
}();

var _default = BackToTop;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var HubspotChat =
/*#__PURE__*/
function () {
  function HubspotChat() {
    _classCallCheck(this, HubspotChat);

    // Check if exists and initialize
    this.$chatButtons = $('.js-web-chat');

    if (this.$chatButtons.length > 0) {
      this.init();
    }
  }

  _createClass(HubspotChat, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      this.$chatButtons.on('click', function () {
        // check if Hubspot chat is installed
        if (window.hubspot_live_messages_running && window.hubspot && window.hubspot.messages) {
          window.hubspot.messages.EXPERIMENTAL_API.requestWidgetOpen();
        } else {
          console.log('Failed to find Hubspot API, verify that Hubspot scripts are running');
        }
      });
    }
  }]);

  return HubspotChat;
}();

var _default = HubspotChat;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InstantQuoteResults = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var InstantQuoteResults =
/*#__PURE__*/
function () {
  function InstantQuoteResults() {
    _classCallCheck(this, InstantQuoteResults);

    // Check if exists and initialize
    this.$quoteResultsContainer = $('#quote-results');

    if (this.$quoteResultsContainer.length > 0) {
      this.init();
    }
  }

  _createClass(InstantQuoteResults, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      //this.$resultsTargetEl = $('#instant-quote-result');
      // if( this.$resultsTargetEl.length > 0 ){
      //     window.renderInstantQuote = this.renderQuote;
      // }else{
      //     alert( "Uh oh! Something's wrong with our Instant Quote. Please report this to customer service at 1-888-650-8648");
      //     console.log( "Instant Quote Error: results target element not found. Expecting an element with ID 'instant-quote-result'" );
      // }
      this.renderQuote();
    }
  }, {
    key: "renderQuote",
    value: function renderQuote() {
      var quotesObjArray = new Array();
      window.quotesResults = new Array();

      if (typeof shipExpertQuoteData !== 'undefined') {
        shipExpertQuoteData.forEach(function (quote, index) {
          // Comment line below for production
          // window.quotesResults.push( quote );
          var quoteObject = {
            'ID': index,
            'carrierID': quote.carrierId,
            'serviceName': quote.serviceName,
            'transitDays': quote.transitDays,
            'modeTransport': quote.modeTransport,
            'totalCharge': quote.totalCharge,
            'totalTariff': quote.totalTariff
          };
          quotesObjArray.push(quoteObject);
          window.quotesResults.push(quoteObject);
        });
        var groundQuoteOptions = quotesObjArray.filter(this.filterQuotesByGround);
        var airQuoteOptions = quotesObjArray.filter(this.filterQuotesByAir);
        var bestGroundQuote = {};
        var bestAirQuote = {};
        var remainingQuotesObjArray = [].concat(quotesObjArray);
        var removeIndex = -1;

        if (airQuoteOptions.length > 0) {
          bestAirQuote = airQuoteOptions.sort(this.sortQuotesByPriceAscending)[0];
          removeIndex = this.findQuoteByID(remainingQuotesObjArray, bestAirQuote.ID);
          remainingQuotesObjArray.splice(removeIndex, 1);
        }

        if (groundQuoteOptions.length > 0) {
          bestGroundQuote = groundQuoteOptions.sort(this.sortQuotesByPriceAscending)[0];
          removeIndex = this.findQuoteByID(remainingQuotesObjArray, bestGroundQuote.ID);
          remainingQuotesObjArray.splice(removeIndex, 1);
        }

        console.log('Here are the ground options:');
        console.log(groundQuoteOptions);
        console.log('------------------------------');
        console.log('Here are the air options:');
        console.log(airQuoteOptions);
        console.log('------------------------------');
        console.log('Best Ground Rate:');
        console.log(bestGroundQuote);
        console.log('------------------------------');
        console.log('Best Air Rate:');
        console.log(bestAirQuote);
        console.log('------------------------------');
        console.log('All Quotes:');
        console.log(quotesObjArray);
        console.log('------------------------------');
        console.log('Quotes Without Best Rates:');
        console.log(remainingQuotesObjArray);
      }
    }
  }, {
    key: "filterQuotesByAir",
    value: function filterQuotesByAir(a) {
      // console.log( 'Mode: ' + a.modeTransport );
      return a.modeTransport == "A" ? true : false;
    }
  }, {
    key: "filterQuotesByGround",
    value: function filterQuotesByGround(a) {
      // console.log( 'Mode: ' + a.modeTransport );
      return a.modeTransport == "G" ? true : false;
    }
  }, {
    key: "sortQuotesByPriceAscending",
    value: function sortQuotesByPriceAscending(a, b) {
      if (a.totalCharge > b.totalCharge) return 1;
      if (b.totalCharge > a.totalCharge) return -1;
      return 0;
    }
  }, {
    key: "sortQuotesByTransitTimes",
    value: function sortQuotesByTransitTimes(a, b) {
      if (a.transitDays > b.transitDays) return 1;
      if (b.transitDays > a.transitDays) return -1;
      return 0;
    }
  }, {
    key: "findQuoteByID",
    value: function findQuoteByID(a, b) {
      var i = a.map(function (item) {
        return item.ID;
      }).indexOf(b);
      return i;
    }
  }]);

  return InstantQuoteResults;
}();

exports.InstantQuoteResults = InstantQuoteResults;
var _default = InstantQuoteResults;
exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Sample module for adding new functionality or website components
 * @example 
 * #Add instructions here
 */
var LazyLoadBGs =
/*#__PURE__*/
function () {
  function LazyLoadBGs() {
    _classCallCheck(this, LazyLoadBGs);

    // Check if exists and initialize
    this.$lazy_bgs = $('.js-lazy-bg');

    if (this.$lazy_bgs.length > 0) {
      this.init();
    }
  }

  _createClass(LazyLoadBGs, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      var lazyBackgrounds = [].slice.call(document.querySelectorAll(".js-lazy-bg"));

      if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
        var lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("bg-visible");
              lazyBackgroundObserver.unobserve(entry.target);
            }
          });
        });
        lazyBackgrounds.forEach(function (lazyBackground) {
          lazyBackgroundObserver.observe(lazyBackground);
        });
      }
    }
  }]);

  return LazyLoadBGs;
}();

var _default = LazyLoadBGs;
exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LazyLoadVideos =
/*#__PURE__*/
function () {
  function LazyLoadVideos() {
    _classCallCheck(this, LazyLoadVideos);

    // Check if exists and initialize
    this.$lazyLoadVideos = $('.js-lazy-load-video');
    this.$lazyLoadModalButton = $('.js-open-lazy-modal-video');

    if (this.$lazyLoadVideos.length > 0) {
      // console.log( 'initializing video lazy loading' );
      this.init();
    }

    if (this.$lazyLoadModalButton.length > 0) {
      // console.log( 'initializing lazy loaded modal video' );
      this.initLazyModalVideo();
    }
  }

  _createClass(LazyLoadVideos, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)       
      this.$lazyLoadVideos.on("click", function (e) {
        return _this.handleVideoClick(e);
      });
    }
  }, {
    key: "initLazyModalVideo",
    value: function initLazyModalVideo() {
      var _this2 = this;

      var targetModalId = this.$lazyLoadModalButton.attr('data-modal-target');
      var $targetModal = $('#' + targetModalId);
      var $modalLazyVideo = $targetModal.find('.js-lazy-load-modal-video');
      var $modalBackdrop = $targetModal.parents('.oxy-modal-backdrop');
      var $modalCloseButton = $targetModal.find('.js-modal-close-btn');

      if ($modalLazyVideo.length > 0) {
        this.$lazyLoadModalButton.on('click.openlazymodal', function (e) {
          _this2.handleLazyModalVideoButtonClick(e, $modalLazyVideo);
        });
      } else {
        console.log('Error: found lazy load button, but couldn\'t find target video with .js-lazy-load-modal-video class');
      }

      $modalBackdrop.on('click', function () {
        _this2.stopVideo($modalLazyVideo);
      }); //$modalCloseButton.on( 'click' , () => { this.stopVideo( $modalLazyVideo ) } );
    }
  }, {
    key: "stopVideo",
    value: function stopVideo($el) {
      // console.log( 'stopping video' );
      //$el.find( 'iframe' ).get(0).contentWindow.postMessage('{"event":"command","func":"stopVideo","args":[]}', '*');
      $el.find('iframe').removeAttr('src', "");
    }
  }, {
    key: "handleVideoClick",
    value: function handleVideoClick(e) {
      // console.log( 'lazy loaded video clicked' );
      var $elm = $(e.currentTarget);
      this.loadVideo($elm);
    }
  }, {
    key: "handleLazyModalVideoButtonClick",
    value: function handleLazyModalVideoButtonClick(e, $modalVideo) {
      // console.log( 'lazy loaded modal video initializing' );
      // console.log( $modalVideo.find('iframe') );
      if ($('body').hasClass('lazy-modal-initialized')) {
        $modalVideo.find('iframe').attr('src', this.modalVideoSrc);
      } else {
        this.loadVideo($modalVideo);
        $('body').addClass('lazy-modal-initialized');
        this.modalVideoSrc = $modalVideo.find('iframe').attr('src');
      }
    }
  }, {
    key: "loadVideo",
    value: function loadVideo($element) {
      // console.log( 'loading element: ' + $element.contents() );
      var $elm = $element,
          conts = $elm.contents(),
          le = conts.length,
          ifr = null;

      for (var i = 0; i < le; i++) {
        if (conts[i].nodeType == 8) ifr = conts[i].textContent;
      }

      $elm.addClass("player").html(ifr);
      $elm.off("click");
    }
  }]);

  return LazyLoadVideos;
}();

var _default = LazyLoadVideos;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountController = exports.QuoteController = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var QuoteController =
/*#__PURE__*/
function () {
  function QuoteController() {
    _classCallCheck(this, QuoteController);

    // Check if exists and initialize
    this.$resultsTargetEl = $('#quote-results');

    if (this.$resultsTargetEl.length > 0) {
      if (typeof shipExpertQuoteData !== 'undefined') {
        $('body').addClass('quotes-found');
        this.init();
      } // else{
      //     // console.log( 'Quote Results Error: quote data not found' );
      //     window.location.replace("http://staging.shipexpert.com/compare-rates/");
      // }

    }
  }

  _createClass(QuoteController, [{
    key: "init",
    value: function init() {
      this.enableDebug == false;
      this.processQuotes();
      this.renderQuotes();
      this.initializeTable();
    }
  }, {
    key: "processQuotes",
    value: function processQuotes() {
      var quotesObjArray = new Array();
      var quotes = shipExpertQuoteData; // Define blacklisted terms to filter out of quote strings

      var blacklistedTerms = Array('DHL', 'FedEx', 'Federal Express', 'UPS', 'Canada Post', 'Purolator', 'Canpar', 'Vitran', 'Old Dominion', 'Polaris', 'Speedy Transport', 'YRC');
      quotes.forEach(function (quote, index) {
        var quoteObject = {
          'ID': index,
          'carrierID': quote.carrierId,
          'serviceName': quote.serviceName,
          'transitDays': quote.transitDays,
          'modeTransport': quote.modeTransport,
          'totalCharge': quote.totalCharge,
          'totalTariff': quote.totalTariff,
          'carrierName': quote.carrierName
        };
        var censoredServiceName = quoteObject['serviceName'];
        blacklistedTerms.forEach(function (term) {
          censoredServiceName = censoredServiceName.replace(term, '').trim();
        });
        quoteObject['serviceName'] = censoredServiceName;
        quotesObjArray.push(quoteObject);
      });
      this.allQuoteOptions = quotesObjArray;
      this.groundQuoteOptions = quotesObjArray.filter(this.filterQuotesByGround);
      this.airQuoteOptions = quotesObjArray.filter(this.filterQuotesByAir);
      this.bestGroundQuote = {};
      this.bestAirQuote = {};
      this.remainingQuotes = [].concat(quotesObjArray);
      var removeIndex = -1;

      if (this.airQuoteOptions.length > 0) {
        this.bestAirQuote = this.airQuoteOptions.sort(this.sortQuotesByPriceAscending)[0];
        removeIndex = this.findQuoteByID(this.remainingQuotes, this.bestAirQuote.ID);
        this.remainingQuotes.splice(removeIndex, 1);
      }

      if (this.groundQuoteOptions.length > 0) {
        this.bestGroundQuote = this.groundQuoteOptions.sort(this.sortQuotesByPriceAscending)[0];
        removeIndex = this.findQuoteByID(this.remainingQuotes, this.bestGroundQuote.ID);
        this.remainingQuotes.splice(removeIndex, 1);
      }
    }
  }, {
    key: "renderQuotes",
    value: function renderQuotes() {
      var output_html = '<div class="shipment-quotes-list">';
      var bestRatesTemplate = '';
      var bestGroundTemplate = '';
      var bestAirTemplate = '';
      var callToActionSectionTemplate = '';
      var hasBestAirQuote = Object.keys(this.bestAirQuote).length;
      var hasBestGroundQuote = Object.keys(this.bestGroundQuote).length;
      var groundTransitDays = 0;
      var groundTransitDaysString = '';
      var airTransitDays = 0;
      var airTransitDaysString = '';

      if (hasBestAirQuote || hasBestGroundQuote) {
        // Build starting structure for best rates section
        bestRatesTemplate = ['<div class="quotes-best-rates c-margin-bottom-l">'].join("<br/>"); // Build html for best ground option

        if (hasBestGroundQuote) {
          groundTransitDays = parseInt(this.bestGroundQuote.transitDays);

          if (groundTransitDays > 1) {
            groundTransitDaysString = 'Delivered in ' + this.bestGroundQuote.transitDays + ' Days';
          }

          if (groundTransitDays == 1) {
            groundTransitDaysString = 'Delivered in 1 Day';
          }

          bestGroundTemplate = ['<div class="best-ground best-rate-box style-h">', '<div class="best-rate-box__badge">', '<div class="rate-box__badge-content">Best Rate!</div>', '<div class="rate-box__badge-shadow"></div>', '</div>', '<div class="best-rate-box__header">', '<h2 class="best-rate-box__heading h-underline h-underline--center-all">Standard</h2>', '<img src="/wp-content/uploads/2020/05/icon-speeding-truck.svg" class="best-rate-box__icon" alt="Best Ground Rate">', '</div>', '<div class="best-rate-box__body">', '<div class="best-rate-box__orig-price">' + this.formatTarrifCharge(this.bestGroundQuote.totalTariff) + '</div>', '<div class="best-rate-box__sale-price">' + this.formatTotalCharge(this.bestGroundQuote.totalCharge) + '</div>', '<div class="best-rate-box__transit-days">' + groundTransitDaysString + ' (' + this.bestGroundQuote.serviceName + ')</div>', '<a href="/signup/" class="theme-button button-lg button-primary-style best-rate-box__button">Ship</a>', '</div>', '</div>'].join("");
        } // Build html for best air option


        if (hasBestAirQuote) {
          airTransitDays = parseInt(this.bestAirQuote.transitDays);

          if (airTransitDays > 1) {
            airTransitDaysString = 'Delivered in ' + this.bestAirQuote.transitDays + ' Days';
          }

          if (airTransitDays == 1) {
            airTransitDaysString = 'Delivered in 1 Day';
          }

          bestAirTemplate = ['<div class="best-air best-rate-box style-h">', '<div class="best-rate-box__badge">', '<div class="rate-box__badge-content">Best Rate!</div>', '<div class="rate-box__badge-shadow"></div>', '</div>', '<div class="best-rate-box__header">', '<h2 class="best-rate-box__heading h-underline h-underline--center-all">Expedited</h2>', '<img src="/wp-content/uploads/2020/08/icon-expedited-package.svg" class="best-rate-box__icon" alt="Best Air Rate">', '</div>', '<div class="best-rate-box__body">', '<div class="best-rate-box__orig-price">' + this.formatTarrifCharge(this.bestAirQuote.totalTariff) + '</div>', '<div class="best-rate-box__sale-price">' + this.formatTotalCharge(this.bestAirQuote.totalCharge) + '</div>', '<div class="best-rate-box__transit-days">' + airTransitDaysString + ' (' + this.bestAirQuote.serviceName + ')</div>', '<a href="/signup/" class="theme-button button-lg button-primary-style best-rate-box__button">Ship</a>', '</div>', '</div>'].join("");
        } // Add best ground and air options to best rates section


        bestRatesTemplate += bestGroundTemplate;
        bestRatesTemplate += bestAirTemplate; // Build closing structure for best rates section

        bestRatesTemplate += '</div>'; // Add best rates section to output html

        output_html += bestRatesTemplate;
      }

      var numQuotesToUnlock = ' ';

      if (this.remainingQuotes.length > 1) {
        numQuotesToUnlock = ' ' + this.remainingQuotes.length + ' ';
      } // Add final CTA section code


      callToActionSectionTemplate = ['<div class="quotes-cta-section c-columns-2 c-columns-m-1 c-columns-gap-m c-padding-xl">', '<div class="quotes-cta-content">', '<h2 class="mt-0 h-underline h-underline--sm-center">More Service Options</h2>', '<p class="c-margin-bottom-l">With Ship Expert, choose the combination of delivery speed, method, price, and courier that best suites your needs. Create an account today to unlock additional service options and start saving money on shipping.</p>', '<div class="quotes-cta-button-wrapper">', '<a href="/signup/" class="theme-button button-lg button-primary-style">Create Account</a>', '<a href="/compare-rates/" class="theme-button button-lg button-tertiary-style">New Quote</a>', '</div>', '</div>', '<div class="quotes-cta-graphics">', '<div class="quotes-cta-graphics-wrapper">', '<img src="/wp-content/uploads/2020/09/icon-unlock-content.svg" class="unlock-quotes-image c-margin-bottom-s" />', '<div class="unluck-quotes-image-subtext style-h c-text-dark c-h5 c-margin-bottom-l">', 'Unlock' + numQuotesToUnlock + 'Additional Quotes', '</div>', '<div class="quotes-cta-logos courier-logos">', '<img alt="fedex logo color" src="/wp-content/uploads/2020/05/fedex-logo-color.png" class="courier-logos__fedex" />', '<img alt="ups logo color" src="/wp-content/uploads/2020/05/ups-logo-color.png" class="courier-logos__ups" />', '<img alt="canpar logo color" src="/wp-content/uploads/2020/05/canpar-logo-color.png" class="courier-logos__canpar" />', '<img alt="dhl logo color" src="/wp-content/uploads/2020/05/dhl-logo-color.png" class="courier-logos__dhl" />', '</div>', '</div>', '</div>', '</div>'].join("");
      output_html += callToActionSectionTemplate;
      output_html += "</div>";
      this.$resultsTargetEl.append(output_html);

      if (this.enableDebug()) {
        console.log('Here are the ground options:');
        console.log(this.groundQuoteOptions);
        console.log('------------------------------');
        console.log('Ground Quotes Sorted by Price');
        console.log(this.groundQuoteOptions.sort(this.sortQuotesByPriceAscending));
        console.log('------------------------------');
        console.log('Best Ground Rate:');
        console.log(this.bestGroundQuote);
        console.log('------------------------------');
        console.log('Here are the air options:');
        console.log(this.airQuoteOptions);
        console.log('------------------------------');
        console.log('Air Quotes Sorted by Price');
        console.log(this.airQuoteOptions.sort(this.sortQuotesByPriceAscending));
        console.log('------------------------------');
        console.log('Best Air Rate:');
        console.log(this.bestAirQuote);
        console.log('------------------------------');
        console.log('All Quotes:');
        console.log(this.allQuoteOptions);
        console.log('------------------------------');
        console.log('Quotes Without Best Rates:');
        console.log(this.remainingQuotes);
      }
    }
  }, {
    key: "initializeTable",
    value: function initializeTable() {
      var _this = this;

      if (_typeof($.fn.DataTable) !== undefined) {
        var tableSettings = {
          paging: false,
          searching: false,
          responsive: {
            details: {
              display: $.fn.dataTable.Responsive.display.modal()
            }
          },
          order: [2, 'asc', 4, 'asc'],
          info: false,
          columnDefs: [{
            targets: '_all',
            orderable: false
          }, {
            targets: [0, 1, 2, 3, 4, 5],
            className: "desktop"
          }, {
            targets: [0, 1, 2, 4, 5],
            className: "tablet, mobile"
          }, {
            targets: [0, 2, 4, 5],
            className: "tablet, mobile"
          }]
        };
        this.table = $('#other-rates-table').DataTable(tableSettings);
        this.table.columns().every(function (el, index, arr) {
          var index = el;
          var header = $('#other-rates-table th:eq(' + index + ')');

          if (index != 5 && index != 1) {
            header.addClass('sorting');
            header.removeClass('sorting_disabled');
            header.on('click', function () {
              return _this.changeOrder(index);
            });
          }

          if (index == 4) {
            header.addClass('sorting_asc');
          }
        });
        window.resultTable = this.table;
      } else {
        console.log("Quote Results Error: table could not be loaded properly. DataTables not found.");
      }
    }
  }, {
    key: "changeOrder",
    value: function changeOrder(clickedIndex) {
      console.log(clickedIndex);

      if (clickedIndex == 4) {
        var $tableCells = $('#other-rates-table').find('tbody td');
        $tableCells.removeClass('sorting_2');
      }

      var currentSort = this.table.order();
      var newOrder = [];
      var clickedOrder = 'asc';
      var addAtEnd = true;

      for (var col in currentSort) {
        if (currentSort[col][0] === clickedIndex) {
          addAtEnd = false;
          clickedOrder = currentSort[col][1];

          if (clickedOrder === 'asc') {
            clickedOrder = 'desc';
            newOrder.push([clickedIndex, clickedOrder]);
          }
        } else {
          newOrder.push(currentSort[col]);
        }
      }

      if (addAtEnd) {
        newOrder.push([clickedIndex, clickedOrder]);
      }

      this.table.order(newOrder).draw();
    }
  }, {
    key: "filterQuotesByAir",
    value: function filterQuotesByAir(a) {
      // console.log( 'Mode: ' + a.modeTransport );
      return a.modeTransport == "A" ? true : false;
    }
  }, {
    key: "filterQuotesByGround",
    value: function filterQuotesByGround(a) {
      // console.log( 'Mode: ' + a.modeTransport );
      return a.modeTransport == "G" ? true : false;
    }
  }, {
    key: "sortQuotesByPriceAscending",
    value: function sortQuotesByPriceAscending(a, b) {
      var priceA = parseFloat(a.totalCharge);
      var priceB = parseFloat(b.totalCharge);
      if (priceA > priceB) return 1;
      if (priceB > priceA) return -1;
      return 0;
    }
  }, {
    key: "sortQuotesByTransitTimes",
    value: function sortQuotesByTransitTimes(a, b) {
      var timeA = parseInt(a.transitDays);
      var timeB = parseInt(a.transitDays);
      if (timeA > timeB) return 1;
      if (timeB > timeA) return -1;
      return 0;
    }
  }, {
    key: "findQuoteByID",
    value: function findQuoteByID(a, b) {
      var i = a.map(function (item) {
        return item.ID;
      }).indexOf(b);
      return i;
    }
  }, {
    key: "formatTarrifCharge",
    value: function formatTarrifCharge(strValue) {
      var tariff = parseFloat(strValue);

      if (tariff == 0) {
        tariff = "";
      } else {
        tariff = '$' + tariff.toFixed(2);
      }

      return tariff;
    }
  }, {
    key: "formatTotalCharge",
    value: function formatTotalCharge(strValue) {
      var price = parseFloat(strValue);

      if (price == 0) {
        price = "Contact Us";
      } else {
        price = '$' + price.toFixed(2);
      }

      return price;
    }
  }]);

  return QuoteController;
}();

exports.QuoteController = QuoteController;

var AccountController =
/*#__PURE__*/
function () {
  function AccountController() {
    _classCallCheck(this, AccountController);

    // Check if exists and initialize
    this.$var = $('selector');

    if (this.$var.length > 0) {
      this.init();
    }
  }

  _createClass(AccountController, [{
    key: "init",
    value: function init() {// Initialize component(s)
    }
  }]);

  return AccountController;
}();

exports.AccountController = AccountController;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SocialSharePopups =
/*#__PURE__*/
function () {
  function SocialSharePopups() {
    _classCallCheck(this, SocialSharePopups);

    // Check if exists and initialize
    this.$socialShareLinks = $('.js-social-share-popup');
    this.viewportMinSize = 768;

    if (this.$socialShareLinks.length > 0 && $(window).width() > this.viewportMinSize) {
      this.init();
    }
  }

  _createClass(SocialSharePopups, [{
    key: "init",
    value: function init() {
      var _this = this;

      // Initialize component(s)
      console.log('social popups initialized');
      this.$socialShareLinks.on('click', function (e) {
        return _this.handleSocialShareLinkClick(e);
      });
    }
  }, {
    key: "handleSocialShareLinkClick",
    value: function handleSocialShareLinkClick(e) {
      e.preventDefault();
      var targetUrl = $(e.currentTarget).attr('href');
      var newWin = window.open(targetUrl, 'sharewindow', 'width=600,height=400');
    }
  }]);

  return SocialSharePopups;
}();

var _default = SocialSharePopups;
exports.default = _default;

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TestimonialSlider =
/*#__PURE__*/
function () {
  function TestimonialSlider() {
    _classCallCheck(this, TestimonialSlider);

    // Check if exists and initialize
    this.$slider = $('.js-init-slider.testimonials-slider');

    if (this.$slider.length > 0) {
      this.init();
    }
  }

  _createClass(TestimonialSlider, [{
    key: "init",
    value: function init() {
      // Initialize component(s)
      this.sliderOptions = {
        arrows: true,
        dots: true,
        appendDots: '.testimonial-slider-controls .slider-dots',
        prevArrow: '.testimonial-slider-controls .slick-arrow.slick-prev',
        nextArrow: '.testimonial-slider-controls .slick-arrow.slick-next'
      };
      this.$slider.slick(this.sliderOptions);
    }
  }]);

  return TestimonialSlider;
}();

var _default = TestimonialSlider;
exports.default = _default;

},{}],9:[function(require,module,exports){
"use strict";

var _backToTop = _interopRequireDefault(require("./modules/back-to-top"));

var _testimonialsSlider = _interopRequireDefault(require("./modules/testimonials-slider"));

var _socialSharePopups = _interopRequireDefault(require("./modules/social-share-popups"));

var _hubspotChat = _interopRequireDefault(require("./modules/hubspot-chat"));

var _shipexpertApi = require("./modules/shipexpert-api");

var _instantQuoteResults = _interopRequireDefault(require("./modules/instant-quote-results"));

var _lazyLoadVideos = _interopRequireDefault(require("./modules/lazy-load-videos"));

var _lazyLoadBg = _interopRequireDefault(require("./modules/lazy-load-bg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */
// import $ from 'jquery';
window.$ = jQuery; // import plugin from './modules/plugin';
// import Sample from './modules/sample-module';

$(document).ready(function () {
  var backToTop = new _backToTop.default();
  var testimonialSlider = new _testimonialsSlider.default();
  var socialSharePopups = new _socialSharePopups.default();
  var hubspotChat = new _hubspotChat.default();
  var quoteController = new _shipexpertApi.QuoteController();
  var lazyLoadVideos = new _lazyLoadVideos.default();
  var lazyLoadBGs = new _lazyLoadBg.default(); //const accountController = new AccountController();
  // const instantQuoteResults = new InstantQuoteResults();

  /** FLYING PAGES */
  // window.FPConfig = {
  //         delay: 0,
  //         ignoreKeywords: [],
  //         maxRPS: 3,
  //         hoverDelay: 50
  // };
}); // $(window).bind( 'load', function(){
//         const dynamicCode = new DynamicCode();
// });

},{"./modules/back-to-top":1,"./modules/hubspot-chat":2,"./modules/instant-quote-results":3,"./modules/lazy-load-bg":4,"./modules/lazy-load-videos":5,"./modules/shipexpert-api":6,"./modules/social-share-popups":7,"./modules/testimonials-slider":8}]},{},[9]);
